import { render, staticRenderFns } from "./UserDetails.vue?vue&type=template&id=0003bb54&scoped=true"
import script from "./UserDetails.vue?vue&type=script&lang=ts"
export * from "./UserDetails.vue?vue&type=script&lang=ts"
import style0 from "./UserDetails.vue?vue&type=style&index=0&id=0003bb54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0003bb54",
  null
  
)

export default component.exports